import React, { useState, useEffect, useCallback } from "react";
import { Skeleton } from "antd";
import "./home.scss"; // 确保你有一个 App.css 文件来包含样式
import VideoBlock from "./VideoBlock";
import CompanyCard from "./CompanyCard"; // 引入子组件
import InfoCard from "./InfoCard"; // 引入子组件
import Resource from "./resource"; // 引入子组件
import axiosInstance from "@/axios/axiosInstance";
import NewsList from "./NewsList";
import CompanyListWithMoreInfo from "./CompanyListWithMoreInfo"; // 引入子组件
// import { pushUrlToBaidu } from "@/utils/baiduPush";

const Home = () => {
  const [inforData, setInforData] = useState([]); // 咨询数据
  const [videoData, setVideoData] = useState([]); // 视频数据
  const [tutorialData, setTutorialData] = useState([]); // 教程数据
  const [computeData, setComputeData] = useState([]); // 计算资源数据

  const [qiyData, setqiyData] = useState([]);
  const [ToolData, setToolData] = useState([]);
  const [loadingCard, SetloadingCard] = useState(true);

  const fetchWithRetry = async (url, options = {}, maxRetries = 3) => {
    let lastError;

    for (let i = 0; i < maxRetries; i++) {
      try {
        const response = await axiosInstance.get(url, options);
        return response;
      } catch (error) {
        lastError = error;
        console.log(`Attempt ${i + 1} failed for ${url}`);

        // 如果不是最后一次尝试，等待一段时间再重试
        if (i < maxRetries - 1) {
          await new Promise((resolve) => setTimeout(resolve, 1000 * (i + 1))); // 递增等待时间
        }
      }
    }
    throw lastError;
  };

  const getToolData = async () => {
    try {
      const response = await axiosInstance.get(
        `/tools/index/list?page=1&limit=12`
      );
      setToolData(response.data.data);
      SetloadingCard(false);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const getqiyData = async () => {
    try {
      const response = await axiosInstance.get(
        `/vendorManager/index/list?page=1&limit=12`
      );
      setqiyData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const getInfordData = async () => {
    try {
      const response = await axiosInstance.get(
        `/information/index/list?limit=10&page=1`
      );
      setInforData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const getVideoData = async () => {
    try {
      const response = await axiosInstance.get(
        `/video/index/list?page=1&limit=8`
      );
      setVideoData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const getTutorialData = async () => {
    try {
      const params = new URLSearchParams({
        limit: 10,
        page: 1,
      });

      const response = await fetchWithRetry(
        `/tutorial/index/list?${params.toString()}`
      );

      if (response?.data?.data) {
        setTutorialData(response.data.data);
      } else {
        console.warn("Tutorial data format unexpected:", response);
        setTutorialData([]);
      }
    } catch (error) {
      console.error("Error fetching tutorial data:", error);
      setTutorialData([]); // 设置空数组作为默认值
    }
  };

  const getComputeData = async () => {
    try {
      const response = await axiosInstance.get(
        `/computPower/index/list?limit=8&page=1`
      );
      setComputeData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.allSettled([
          getInfordData(),
          getVideoData(),
          getComputeData(),
          getqiyData(),
          getToolData(),
          getTutorialData(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();

    // // 推送当前页面 URL 到百度
    // pushUrlToBaidu(window.location.href)
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log("URL 推送成功:", data);
    //   })
    //   .catch((error) => {
    //     console.error("URL 推送失败:", error);
    //   });
  }, []);

  const renderVideoBlocks = (videoData) => {
    return videoData.map((block, index) => (
      <VideoBlock key={index} value={block} videoImg={videoData} />
    ));
  };
  return (
    <div>
      <div className="content_body">
        <div className="app-container">
          <NewsList inforData={inforData} />
        </div>
        <div className="content-title">
          <h2>AI视频课程</h2>
          <a target="_blank" href="/videotutorials" rel="noreferrer">
            更多&gt;&gt;
          </a>
        </div>
        <div className="video-blocks-container">
          {videoData && videoData.length > 0 ? (
            <>
              <div className="video-block-row video-block-row-fis">
                {renderVideoBlocks(videoData).slice(0, 4)}
              </div>
              <div className="video-block-row">
                {renderVideoBlocks(videoData).slice(4)}
              </div>
            </>
          ) : (
            <Skeleton active paragraph={{ rows: 4 }} />
          )}
        </div>
        <div className="content-title">
          <h2>热门工具</h2>
          <a href="/tool" target="_blank" rel="noreferrer">
            更多&gt;&gt;
          </a>
        </div>
        <div className="compan-container">
          <div className="company-row">
            {ToolData.map((company, index) => (
              <CompanyCard key={index} {...company} loading={loadingCard} />
            ))}
          </div>
        </div>
        <div className="content-title">
          <h2>AI计算资源</h2>
          <a target="_blank" href="/computationaltrading" rel="noreferrer">
            更多&gt;&gt;
          </a>
        </div>
        <div className="resource">
          <Resource computeData={computeData} />
        </div>
        <div className="content-title wenz">
          <h2>AI教程</h2>
        </div>
        <div className="home-container">
          {tutorialData.length ? (
            tutorialData.map((card, index) => (
              <InfoCard
                key={index}
                imageUrl={card.imageUrl}
                title={card.title}
                dec={card.digest}
                author={card.nickName}
                reads={card.reads}
                time={card.createTime}
                value={card}
              />
            ))
          ) : (
            <>
              <Skeleton active paragraph={{ rows: 1 }} />
              <Skeleton active />
            </>
          )}
        </div>
        <div className="content-title">
          <h2>AI先锋企业</h2>
          <a target="_blank" href="/videotutorials" rel="noreferrer">
            更多&gt;&gt;
          </a>
        </div>
        <CompanyListWithMoreInfo images={qiyData} />
      </div>
    </div>
  );
};

export default Home;
